import { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  FaChevronLeft,
  FaChevronRight,
  FaSignOutAlt,
  FaSpinner,
} from "react-icons/fa";
import { AuthContext } from "../context/AuthContext";
import BildirimWidget from "./Notification";
import "./Sidebar.css";
import logoImage from "../assets/logos/logo.png";
import profileIcon from "../assets/icons/profile.png";

import productionIcon from "../assets/icons/production-ico.png";
import producerIcon from "../assets/icons/produce-icon.png";
import clusterIcon from "../assets/icons/cluster-icon1.png";
import performanceIcon from "../assets/icons/performance-icon.png";
import accountingIcon from "../assets/icons/accounting-icon.png";
import settingsIcon from "../assets/icons/settings-icon.png";
import faqIcon from "../assets/icons/faq-icon.png";
import accountIcon from "../assets/icons/account-icon.png";
import supportIcon from "../assets/icons/support-icon.png";
import manualIcon from "../assets/icons/manual-icon.png";
import licenseIcon from "../assets/icons/license-icon.png";
import { getKullaniciBilgileri } from "../services/api";

const Sidebar = ({ isMobileMenuOpen, closeMobileMenu }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { handleLogout } = useContext(AuthContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [userAdi, setUserAdi] = useState("");
  const [userSoyadi, setUserSoyadi] = useState("");
  const [kullaniciId, setKullaniciId] = useState(null);
  const [userInitilazed, setUserInitialized] = useState(false);

  useEffect(() => {





    const handleResize = () => {
      setIsMobileView(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        let response = await getKullaniciBilgileri();
        if (response.data.data) {
          const userData = response.data.data[0];
          setUserAdi(userData.KULLANICI_ADI);
          setUserSoyadi(userData.KULLANICI_SOYADI);
          setKullaniciId(userData.KULLANICI_ID);
          setUserInitialized(true);
        }
      } catch (error) {
        // console.error("Kullanıcı bilgileri alınırken hata:", error);
      }
    };

    fetchUserData();
  }, []);

  const menuItems = [
    
    {
      id: "production",
      name: "Üretim Dönemi",
      icon: productionIcon,
      path: "/uretim-donemi",
    },
    {
      id: "producer",
      name: "Üretici Bilgileri",
      icon: producerIcon,
      path: "/uretici-bilgileri",
    },
    {
      id: "bakici",
      name: "Bakıcı Bilgileri",
      icon: profileIcon,
      path: "/bakicilarim",
    },
    {
      id: "cluster",
      name: "Kümes Bilgileri",
      icon: clusterIcon,
      path: "/kume-bilgileri",
    },
    {
      id: "kumeskarti",
      name: "Kümes Kartları",
      icon: clusterIcon,
      path: "/kumes-karti",
    },
    {
      id: "performance",
      name: "Performans Raporları",
      icon: performanceIcon,
      path: "/performans-raporlari",
    },
    {
      id: "accounting",
      name: "Muhasebe Raporları",
      icon: accountingIcon,
      path: "/muhasebe-raporlari",
    },
    // {
    //   id: "settings",
    //   name: "Sistem Uyarıları",
    //   icon: settingsIcon,
    //   path: "/sistem-uyarilari",
    // },
    { id: "faq", name: "Merak Ettikleriniz", icon: faqIcon, path: "/sss" },
    {
      id: "account",
      name: "Hesap Bilgilerim",
      icon: accountIcon,
      path: "/hesap-bilgilerim",
    },
    {
      id: "support",
      name: "Destek Talepleri",
      icon: supportIcon,
      path: "/destek-talepleri",
    },
    {
      id: "manual",
      name: "Kullanım Kılavuzu",
      icon: manualIcon,
      path: "/kullanim-kilavuzu",
    },
    {
      id: "license",
      name: "Lisans Koşulları",
      icon: licenseIcon,
      path: "/lisans-kosullari",
    },
  ];




  const activeItem =
    menuItems.find((item) => location.pathname.includes(item.path))?.id ||
    "production";

  const handleMenuItemClick = (path) => {
    navigate(path);
    if (isMobileView && closeMobileMenu) {
      closeMobileMenu();
    }
  };

const handleLogoutClick = async () => {
  if (isLoggingOut) return;

  const confirmLogout = window.confirm(
    "Çıkış yapmak istediğinizden emin misiniz?"
  );
  if (!confirmLogout) return;

  setIsLoggingOut(true);

  try {
    await handleLogout();
  } catch (err) {
    console.error("Logout failed:", err);
  } finally {
    setIsLoggingOut(false);
  }
};

  const isEffectivelyCollapsed = collapsed && !isMobileView;

  return (

    
    <div
      className={`sidebar ${isEffectivelyCollapsed ? "collapsed" : ""} ${
        isMobileMenuOpen ? "mobile-open" : ""
      }`}
    >
      <div className="sidebar-header">
        {!isEffectivelyCollapsed && (
          <div className="logo-container">
            <img src={logoImage} alt="E-Kümes Logo" className="sidebar-logo" />
          </div>
        )}
        {/* Bildirim Widget'ı Ekledik */}

        <div className="sidebar-header-actions">
          {/* {userInitilazed ? (
            <BildirimWidget
              collapsed={isEffectivelyCollapsed}
              kullaniciId={kullaniciId}
              dataFetched={userInitilazed}
            />
          ) : null} */}
          {!isMobileView && (
            <button
              className="collapse-btn"
              onClick={() => setCollapsed(!collapsed)}
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
            </button>
          )}
        </div>
      </div>

      <div className="sidebar-menu">
        {menuItems.map((item) => (
              <div
                key={item.id}
                className={`menu-item ${activeItem === item.id ? "active" : ""}`}
                onClick={() => handleMenuItemClick(item.path)}
                onMouseDown={(e) => e.preventDefault()}
                data-tooltip={item.name}
                role="button"
                tabIndex={0}
              >
            <div className="menu-icon">
              <img src={item.icon} alt={item.name} />
            </div>
            {!isEffectivelyCollapsed && <span>{item.name}</span>}
          </div>
        ))}
      </div>

      <div className="sidebar-footer">
        {!isEffectivelyCollapsed && (
          <div className="user-profile">
            <img src={profileIcon} alt="Kullanıcı" color="white" />
            <span>
              {" "}
              {userAdi === "" || userAdi == null
                ? "Kullanıcı Adı"
                : userAdi}{" "}
              {userSoyadi === "" || userSoyadi == null
                ? "Kullanıcı Soyadı"
                : userSoyadi}
            </span>
          </div>
        )}

            <div
              className={`menu-item logout-section ${isLoggingOut ? "disabled" : ""}`}
              onClick={handleLogoutClick}
              onMouseDown={(e) => e.preventDefault()}
              data-tooltip="Çıkış Yap"
              role="button"
              tabIndex={0}
            >
          <div className="menu-icon">
            {isLoggingOut ? (
              <FaSpinner className="spinner" />
            ) : (
              <FaSignOutAlt />
            )}
          </div>
          {!isEffectivelyCollapsed && (
            <span>{isLoggingOut ? "Çıkış Yapılıyor..." : "Çıkış Yap"}</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
